import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumb } from "../../../components/Breadcrumb";

export const Units = () => {
    document.title = "Ölçü vahidləri";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Kassa", value: "/cash" },
        { name: "Ölçü vahidləri", value: "/cash/units", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Ölçü vahidləri</h2>
                    <p>
                        Bir məhsulun bir neçə ölçü vahidi olduqda kassadan satış zamanı seçim etmək üçün nəzərdə tutulub. Ölçü vahidlərini formalaşdırmaq üçün
                        linkə keçid edin. <Link to={"/products/parameters/kit"}>Ölçü vahidləri</Link>
                    </p>
                    <h3>Misal 1</h3>
                    <p>
                        Əgər istifadəçi, Pol taxtası məhsulunu həm m həm də ədədlə satmaq istəyirsə, məhsulu satış üçün səbətə əlavə edəndə ölçü vahidini təyin
                        etməlidir.
                    </p>
                    <img src="/images/cash/units-1.gif" alt="Ölçü vahidləri" />

                    <h3>Misal 2</h3>
                    <p>
                        Əgər istifadəçi, Bolt 25 məhsulunu həm qutu həm də ədədlə satmaq istəyirsə, məhsulu satış üçün səbətə əlavə edəndə ölçü vahidini təyin
                        etməlidir
                    </p>
                    <img src="/images/cash/units-2.gif" alt="Ölçü vahidləri" />
                </article>
            </div>
        </div>
    );
};
